// src/common/utils/events.ts
/**
* Determines if a click event is a left-mouse button click without modifiers.
*/
const isLmbClick = (event) => !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
export { isLmbClick };

//# sourceMappingURL=events.js.map